/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  console.log("currentUser",currentUser)
  const _canAdmin = currentUser?.access === 'admin';
  const _canTeacher = currentUser?.access === 'teacher';
  const _canSuperAdmin = currentUser?.access === 'super_admin';
  const managerlv = Number(
    (currentUser as any)?.managerlv ??
      (typeof window !== 'undefined' ? window.localStorage?.getItem('managerlv') : undefined) ??
      0,
  );
  const userId = Number(
    (currentUser as any)?.userid ??
      (currentUser as any)?.player_id ??
      (typeof window !== 'undefined' ? window.localStorage?.getItem('player_id') : undefined) ??
      0,
  );
  const canSelfAllocateQuota = managerlv > 0 && userId === 54;
  return {
    
    canAdmin: currentUser && currentUser.access === 'admin',
    canSuperAdmin: currentUser && currentUser.access === 'super_admin',
    canTeacher: currentUser && currentUser.access === 'teacher',
    canTeacherOrAdmin: _canAdmin || _canTeacher,
    canSuperAdminOrAdmin: _canSuperAdmin || _canAdmin,
    // 广告管理：沿用超管/管理员，学校管理员 managerlv=6 不显示
    canAdvertisement: (_canSuperAdmin || _canAdmin) && managerlv !== 6,
    canDistributorRoot: _canSuperAdmin || _canAdmin || canSelfAllocateQuota,
    canSelfAllocateQuota,
    canSuperAdminOrTeacher: _canSuperAdmin || _canTeacher,
    canSuperAdminOrAdminOrTeacher: _canSuperAdmin || _canAdmin || _canTeacher,
    canManagerLv1: managerlv === 1,
    canManagerLv6: managerlv === 6,
    canManagerLv1Or6: managerlv === 1 || managerlv === 6,
    // 课程开通：managerlv 1 / 2 / 3 / 6
    canManagerLv123Or6: [1, 2, 3, 6].includes(managerlv),
    canManagerLvLessThan6: managerlv < 6,
    canManagerLvGt0: managerlv > 0,
    canTeacherOrManagerLv1: _canTeacher || managerlv === 1,
    canTeacherOrManagerLvGt0: _canTeacher || managerlv > 0,
    // 分配班级课程：超管/管理员/教师，或学校管理员 managerlv=6
    canAssignClassCourse:
      _canSuperAdmin || _canAdmin || _canTeacher || managerlv === 6,
  };
}
